var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("../assets/img/404.svg"),"alt":""}})]),_c('p',{staticClass:"error-tips"},[_vm._v("服务器故障，网站暂停访问，技术人员正在修复，请稍后再来")])])
}]

export { render, staticRenderFns }